import React from 'react';
import { ArrowRight } from 'react-feather';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageMeta } from './PageMeta';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="flex flex-col min-h-screen" data-id="element-50">
      <PageMeta title="Wojtek Swiatoniowski | Designer. Doer." description="I work where policy, technology, and human judgement meet." data-id="element-51" />
      <Header data-id="element-52" />

      <main className="flex-1 w-full flex items-center" data-id="element-53">
        <div className="w-full px-8 py-12 md:py-16" data-id="element-54">
          <div className="max-w-[1200px] mx-auto" data-id="element-55">
            <h1 className="hidden md:flex text-fluid-4xl md:text-[clamp(4.209rem,5vw,5.61rem)] font-bold mb-8 uppercase animate-fadeIn flex-col tracking-tight" data-id="element-56">
              <span className="mb-2" data-id="element-57">Wojtek Swiatoniowski</span>
              <span data-id="element-58">Designer. Doer.</span>
            </h1>

            <h1 className="md:hidden text-fluid-3xl font-bold mb-6 uppercase animate-fadeIn flex flex-col tracking-tight" data-id="element-59">
              <span className="mb-2" data-id="element-60">Wojtek</span>
              <span className="mb-2" data-id="element-61">Swiatoniowski</span>
              <span data-id="element-62">Designer. Doer.</span>
            </h1>

            <div className="text-[1.1rem] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)] text-[#7A8290] animate-fadeIn flex flex-col gap-3" data-id="element-63">
              <span className="block" data-id="element-64">
                I work where policy, technology, and human judgement meet.
              </span>
              <span className="block" data-id="element-65">My focus:</span>
              <ul className="flex flex-col gap-3 items-start" aria-label="Areas of specialization" data-id="element-66">
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-67">
                  <a href="/complexity" onClick={e => {
                  e.preventDefault();
                  onNavigate('complexity');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="Making complexity navigable" data-id="element-68">
                    Making complexity navigable
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-69" />
                  </a>
                </li>
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-70">
                  <a href="/research" onClick={e => {
                  e.preventDefault();
                  onNavigate('research');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="Turning research into decisions" data-id="element-71">
                    Turning research into decisions
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-72" />
                  </a>
                </li>
                <li className="hover:translate-x-2 transition-all duration-300 block group" data-id="element-73">
                  <a href="/systems" onClick={e => {
                  e.preventDefault();
                  onNavigate('systems');
                }} className="inline-flex items-center gap-2 text-[#7A8290] hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-1 focus:ring-offset-[#111111] rounded-sm whitespace-nowrap" aria-label="Building systems that last" data-id="element-74">
                    Building systems that last
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-75" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-76" />
    </div>;
}